import { render } from "./EditXyWorkHis.vue?vue&type=template&id=36626d58"
import script from "./EditXyWorkHis.vue?vue&type=script&lang=js"
export * from "./EditXyWorkHis.vue?vue&type=script&lang=js"

import exportComponent from "I:\\JavaWork\\Recruit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__